module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabBox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ibox-content"
    }
  }, _vm._l((_vm.versionList), function(versionInfo, index) {
    return _c('div', {
      staticClass: "vertical-container light-timeline",
      attrs: {
        "id": "vertical-timeline"
      }
    }, [_c('div', {
      staticClass: "vertical-timeline-block"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "vertical-timeline-content"
    }, [_c('h2', [_vm._v(_vm._s(versionInfo.versionName))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(versionInfo.content)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "vertical-date"
    }, [_c('small', [_vm._v(_vm._s(versionInfo.versionDate))])])])])])
  }), 0), _vm._v(" "), _c('main-modal', {
    ref: "modal1",
    attrs: {
      "size": "small",
      "title": "提示"
    }
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.tipContent)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closetip
    }
  }, [_vm._v("关闭")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center float-e-margins p-md"
  }, [_c('h3', [_vm._v("系统升级详情")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-timeline-icon blue-bg"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c5c1e9a","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Update.vue
// module id = 1459
// module chunks = 0